module.exports = __webpack_public_path__ + "img/portfolio2.5c2aba7e.svg";